<template>

    <div class="bg-white h-full">
        <Image src="/page-2.jpg" class="w-full h-full object-contain" />
    </div>

</template>